import * as React from 'react';
import { LoadingButton } from '@mui/lab';
import { Tooltip } from '@mui/material';
import { ReactComponent as DownloadIcon } from 'assets/icons/download-icon.svg';
import { useSelectionContext, useSelectionCount } from 'common/contexts/SelectionContext';

interface Props {
  onClick: () => void;
  loading?: boolean;
}

export const ExportButton: React.FC<Props> = (props) => {
  const { onClick, loading } = props;
  const { selection } = useSelectionContext();

  const count = useSelectionCount(selection);

  let label = 'Export all';
  switch (selection.model) {
    case 'filter':
      label = `Export all (${count.toLocaleString()})`;
      break;
    case 'page':
      label = `Export selection (${count.toLocaleString()})`;
      break;
    default:
      break;
  }

  return (
    <Tooltip title={loading ? 'Export in progress...' : ''}>
      <span>
        <LoadingButton
          onClick={onClick}
          loading={loading}
          variant="outlined"
          classes={{
            loadingIndicator: 'text-blue-900',
          }}
        >
          <DownloadIcon className="w-4 h-4 mr-1" />
          <h4 className="font-medium">{label}</h4>
        </LoadingButton>
      </span>
    </Tooltip>
  );
};
ExportButton.displayName = 'ContainerActions.ExportButton';
